<template>
  <div class="invitation_container">
    <div class="invitation_box">

      <p class='code_title'>您的邀请码</p>

      <div class="code_box">
        <span v-for='code in inviteCode' :key='code'>{{code}}</span>
      </div>

      <p class="explain">邀请的好友也可以在APP中填写邀请码</p>

      <!-- <p class="nickName">用户名：{{nickName}}</p> -->

      <!-- <p class="invitation_num">已成功邀请<span class="num">{{num}}</span>人</p> -->

      <div class="invitation_code_img_box" id='qrcode' ref="qrCodeUrl"></div>
      <div class="tips_box"><span class="tips">扫码邀请</span></div>


    <div class="operate_tips_box">
      <p class="black_info">每邀请一个好友下载<span v-text="appName"></span>APP并注册成功</p>
      <p class="red_info">你都能获取<span v-text="point"></span>积分，快去邀请吧！</p>
      <span class="operate_btn" @click="shareHandler">邀请好友，赚取积分</span>
    </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import QRCode from "qrcodejs2";
export default {
  name: "Invitation",
  data() {
    return {
      inviteCode: '------',
      point: 0,
      pageData: {
        title: "",
        info: "",
        shareUrl: "https://newapp2.farmer.com.cn/share/#/download",
        imageUrl: "",
      },
    };
  },
  computed: {
    ...mapState("app", ["shareRootUrl", "appName", "appFullName"]),
  },
  methods: {
    /* 分享功能 */
    shareHandler() {
      var shareStr = JSON.stringify(this.pageData);
      // 调用客户端方法，将分享信息传给客户端
      if (window.java) {
        window.java.setShareInfo(shareStr);
      } else {
        this.$bridge.callhandler("setShareInfo", shareStr, (data) => { });
      }
    },
    createQrCode() {
      document.getElementById("qrcode").innerHTML = "";
      var w = this.$refs.qrCodeUrl.clientWidth - 30;
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.pageData.shareUrl, // 需要转换为二维码的内容
        width: w,
        height: w,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
    }
  },
  created() {
    document.title = "邀请好友";
    loadStat(); // 友盟统计
    this.pageData.imageUrl = this.shareRootUrl.replace("/#/", "/") + require('@/assets/images/logo/logo.png');

    this.pageData.title = "我正在" + this.appName + "邀请好友赚积分，快帮我"
    this.pageData.info = "下载" + this.appFullName + "，了解更多精彩资讯"
  },
  mounted() {
    var _this = this;
    window.setInviterInfo = (res) => {
      var data = JSON.parse(res);
      _this.inviteCode = data.inviteCode;
      _this.point = data.point;
      _this.pageData.shareUrl = _this.shareRootUrl + "index_share?contentType=invite&inviteCode=" + _this.inviteCode + "&appName=" + encodeURI(_this.appName);
      _this.createQrCode();
    }
    this.createQrCode()
  },
};
</script>
<style scoped lang="scss">
.invitation_container {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: linear-gradient(to right,#d71659,#ed824c);
  display: flex;
  flex-direction: column;
  justify-content: center;
  .invitation_box {
    position: relative;
    padding: 20px 15px;
    background: #fff;
    text-align: center;
    margin: 0 20px;
    border-radius: 15px;
    box-shadow: 0px 0px 9px 2px #f69e72;
    .code_title{
      padding-top: 10px;
      text-align: center;
      font-weight: 600;
      font-size: 26px;
    }
    .code_box{
      text-align: center;
      font-size: 20px;
      color: #d94f28;
      span{
        display: inline-block;
        width: 30px;
        height: 40px;
        line-height: 40px;
        margin: 20px 5px 0 5px;
        background: #e1dfe0;
        font-size: 28px;
        font-weight: 600;
      }
    }

    .explain{
      color: #dadada;
      margin: 5px;
      font-size: 12px;
    }
    .nickName{
      color: #979797;
      font-size: 20px;
      margin: 20px 0 5px 0;
    }
    .invitation_num{
      color: #979797;
      font-size: 20px;
      .num{
        color: #c51c3b;
        font-size: 30px;
        padding: 0 2px;
      }
    }
    .doenload_img {
      width: 70%;
      margin: auto;
    }
    .bg_img_box {
      position: relative;
      width: 100%;
      margin: auto;
      img {
        display: block;
        width: 100%;
      }
      .code {
        position: absolute;
        left: 0;
        top: 65%;
        width: 100%;
        height: 8vw;
        line-height: 8vw;
        font-size: 5vw;
      }
    }
  }
  .invitation_code_img_box {
    position: relative;
    max-width: 200px;
    padding: 15px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    justify-content: center;
    img {
      display: block;
      width: 100%;
    }
  }
  .tips_box {
    width: 100%;
    line-height: 24px;
    padding-bottom: 12px;
    border-bottom: 1px solid #d6d6d6;
    margin-bottom: 12px;
    color: #838383;
    text-align: center;
    font-size: 13px;
  }
  .operate_tips_box {
    width: 100%;
    .black_info {
      width: 100%;
      line-height: 50px;
      padding: 0 12px;
      color: #d71659;
      text-align: center;
      font-size: 13px;
    }
    .red_info {
      width: 100%;
      line-height: 36px;
      padding: 0 12px;
      color: #d71659;
      text-align: center;
      font-size: 16px;
    }
    .operate_btn {
      display: block;
      width: 90%;
      height: 36px;
      line-height: 36px;
      background-color: #df3435;
      margin: 5px 5%;
      text-align: center;
      color: #f2ebeb;
      font-size: 14px;
      border-radius: 3px;
    }
  }
}
@media screen and (min-width: 750px) {
  .invitation_container {
    .invitation_box {
      .bg_img_box {
        .code {
          height: 60px;
          line-height: 60px;
          font-size: 37.5px;
        }
      }
    }
  }
}
</style>